import * as React from 'react';

import { PortalErrorBoundary } from '~/components/PortalErrorBoundary';
import { Sidebar } from '~/components/Sidebar';
import { SidebarMenuLevel } from '~/components/Sidebar/components/SidebarMenuLevel';
import { SidebarLayout } from '~/scenes/PortalViews/components/SidebarLayout';
import { StructuredModuleRouter } from '~/scenes/PortalViews/components/StructuredModuleRouter';
import { useAnalyticsViews } from '~/scenes/PortalViews/Views/AnalyticsViews/useAnalyticsViews';

export const AnalyticsViews = () => {
  const { navigationPaths, routingStructure } = useAnalyticsViews();

  return (
    <SidebarLayout
      sidebar={
        <Sidebar>
          <SidebarMenuLevel
            navigationRootPath={'/portal/analytics'}
            parentLevels={[]}
            levelPaths={navigationPaths}
          />
        </Sidebar>
      }
    >
      <PortalErrorBoundary>
        <StructuredModuleRouter routingStructure={routingStructure} />
      </PortalErrorBoundary>
    </SidebarLayout>
  );
};
